@if (isAuthenticated) {
    <button
        cdkDrag
        cdkDragLockAxis="y"
        [cdkDragFreeDragPosition]="fabDragPosition"
        [cdkDragConstrainPosition]="constrainFabPosition"
        (cdkDragEnded)="onFabDragEnded($event)"
        class="helpdesk-fab fixed z-90 flex items-center justify-center w-12 h-12 rounded-full bg-primary text-white shadow-lg cursor-grab print:hidden hover:shadow-xl active:cursor-grabbing"
        style="bottom: 24px; right: 24px"
        matTooltip="Soporte"
        matTooltipPosition="left"
        (click)="openCreateTicketModal()">
        <i class="fas fa-headset text-lg"></i>
    </button>
}
